/*
 * R44 Performance — Tuning configurator
 * Reads the JSON printed by sections/r44-tuning-platform.liquid and runs the step-by-step builder.
 * No dependencies. Works with any theme.
 */
(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function arr(a) { return Array.isArray(a) ? a : []; }
  var ICON_CHAT = '<svg class="r44t-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 12a8 8 0 0 1-11.8 7L4 20l1.1-4.6A8 8 0 1 1 21 12z"/><path d="M8.5 11h.01M12 11h.01M15.5 11h.01"/></svg>';
  var ICON_PHONE = '<svg class="r44t-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/></svg>';
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.localStorage.getItem(key) || 'null');
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  function Configurator(el) {
    this.el = el;
    var dataEl = document.getElementById('r44t-data-' + el.getAttribute('data-section'));
    this.d = JSON.parse(dataEl.textContent);
    this.p = this.d.platform;
    this.cfg = this.d.settings || {};
    this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.cfg.currency || 'GBP' });
    this.saveKey = 'r44t:' + this.p.handle;

    // Index every product by id so selections can be looked up quickly
    this.products = {};
    var self = this;
    arr(this.d.steps).forEach(function (st) {
      st.products = arr(st.products); st.productsAfterSplit = arr(st.productsAfterSplit);
      st.products.concat(st.productsAfterSplit).forEach(function (pr) { self.products[pr.id] = pr; });
    });
    this.upsells = arr(this.d.upsells).map(function (g) {
      g.products = arr(g.products).filter(function (pr) { return pr.variants.some(function (v) { return v.available; }); });
      g.products.forEach(function (pr) { self.products[pr.id] = pr; });
      return g;
    }).filter(function (g) { return g.products.length; });

    this.state = this.load() || this.fresh();
    this.buildSteps();
    this.bind();
    this.render();
  }

  Configurator.prototype.fresh = function () {
    return { step: 0, body: null, year: null, sel: {}, upsell: {}, upsellTab: 0, pending: {}, details: {}, legal: false, buildId: 'TUN-' + Date.now().toString(36).toUpperCase() };
  };
  Configurator.prototype.load = function () {
    var s = store(this.saveKey);
    return s && s.buildId ? s : null;
  };
  Configurator.prototype.save = function () { store(this.saveKey, this.state); };

  Configurator.prototype.buildSteps = function () {
    var steps = [{ type: 'car', title: 'Your car' }];
    this.activeSteps().forEach(function (st) { steps.push({ type: 'step', title: st.title, step: st }); });
    if (this.upsells.length) steps.push({ type: 'upsell', title: 'Complete the build' });
    steps.push({ type: 'details', title: 'Your details' });
    steps.push({ type: 'review', title: 'Review' });
    this.steps = steps;
    if (this.state.step >= steps.length) this.state.step = 0;
  };

  /* ---------- Logic ---------- */

  // Steps that apply to this car (some are hidden for newer model years)
  Configurator.prototype.activeSteps = function () {
    var newer = this.isNewer();
    return arr(this.d.steps).filter(function (st) { return !(newer && st.hideAfterSplit); });
  };

  Configurator.prototype.isNewer = function () {
    var sy = this.p.splitYear, y = parseInt(this.state.year, 10);
    return !!(sy && y && y >= sy);
  };
  Configurator.prototype.visible = function (st) {
    return this.isNewer() && st.productsAfterSplit.length ? st.productsAfterSplit : st.products;
  };
  Configurator.prototype.selOf = function (st) {
    return this.state.sel[st.id] || (this.state.sel[st.id] = { mode: null, items: {} });
  };
  Configurator.prototype.variantOf = function (pid, vid) {
    var pr = this.products[pid];
    if (!pr) return null;
    return pr.variants.filter(function (v) { return String(v.id) === String(vid); })[0] || null;
  };

  // Hardware keys the car will have once the package is fitted
  Configurator.prototype.hardware = function () {
    var keys = {}, self = this;
    this.activeSteps().forEach(function (st) {
      var s = self.selOf(st);
      if (s.mode === 'fitted' && st.key) keys[st.key] = true;
      if (s.mode === 'products') {
        Object.keys(s.items).forEach(function (pid) {
          if (st.key) keys[st.key] = true;
          var pr = self.products[pid];
          arr(pr && pr.covers).forEach(function (k) { keys[String(k).trim()] = true; });
        });
      }
    });
    return keys;
  };
  Configurator.prototype.stage = function () {
    var hw = this.hardware(), best = null;
    arr(this.d.stages).forEach(function (s) {
      if (arr(s.requires).every(function (k) { return hw[String(k).trim()]; })) best = s;
    });
    return best;
  };
  Configurator.prototype.nextStage = function () {
    var cur = this.stage(), stages = arr(this.d.stages), hw = this.hardware();
    var i = cur ? stages.indexOf(cur) + 1 : 0;
    var nxt = stages[i];
    if (!nxt) return null;
    var titles = {};
    this.activeSteps().forEach(function (st) { if (st.key) titles[st.key] = st.title; });
    var missing = arr(nxt.requires).filter(function (k) { return !hw[String(k).trim()]; }).map(function (k) { return titles[k] || k; });
    return { stage: nxt, missing: missing };
  };
  Configurator.prototype.needsLegal = function () {
    var self = this;
    return this.activeSteps().some(function (st) { var s = self.selOf(st); return st.legal && s.mode === 'products' && Object.keys(s.items).length; });
  };

  // Everything that will go in the basket
  Configurator.prototype.lines = function () {
    var out = [], self = this, extras = {};
    var stg = this.stage();
    if (stg && stg.variant) out.push({ group: 'Tune', id: stg.variant.id, title: stg.variant.title, variant: stg.variant.variantTitle, price: stg.variant.price, qty: 1, tune: true });
    if (stg && stg.variant) arr(this.d.included).forEach(function (iv) {
      out.push({ group: 'Tune', id: iv.id, title: iv.title, variant: iv.variantTitle, price: iv.price, qty: 1, included: true });
    });
    this.activeSteps().forEach(function (st) {
      var s = self.selOf(st);
      if (s.mode !== 'products') return;
      Object.keys(s.items).forEach(function (pid) {
        var pr = self.products[pid], v = self.variantOf(pid, s.items[pid]);
        if (pr && v) out.push({ group: st.key ? 'Hardware' : 'Services', step: st, id: v.id, title: pr.title, variant: v.title, price: v.price, qty: 1 });
      });
      // Auto-added parts (e.g. gaskets) — one set even if two steps ask for them
      if (st.companion && Object.keys(s.items).length) {
        var c = st.companion, q = st.companionQty || 1;
        if (!extras[c.id] || extras[c.id].qty < q) extras[c.id] = { group: 'Hardware', id: c.id, title: c.title, variant: c.variantTitle, price: c.price, qty: q, auto: true };
      }
    });
    Object.keys(extras).forEach(function (k) { out.push(extras[k]); });
    Object.keys(this.state.upsell).forEach(function (pid) {
      var pr = self.products[pid], v = self.variantOf(pid, self.state.upsell[pid]);
      if (pr && v) out.push({ group: 'Build upgrades', id: v.id, title: pr.title, variant: v.title, price: v.price, qty: 1, upsell: true });
    });
    return out;
  };
  Configurator.prototype.total = function () {
    return this.lines().reduce(function (t, l) { return t + (l.price || 0) * (l.qty || 1); }, 0);
  };
  Configurator.prototype.fmt = function (cents) { return this.money.format((cents || 0) / 100); };

  Configurator.prototype.stepValid = function (i) {
    var s = this.steps[i], st = this.state;
    if (s.type === 'car') return !!st.year && (!arr(this.p.bodies).length || !!st.body);
    if (s.type === 'step') {
      var sel = this.selOf(s.step);
      if (!s.step.required) return true;
      return sel.mode === 'fitted' || sel.mode === 'skip' || (sel.mode === 'products' && Object.keys(sel.items).length > 0);
    }
    if (s.type === 'details') {
      var d = st.details;
      var ok = !!(d.reg && d.mileage && d.phone);
      if (d.vin && !/^[A-HJ-NPR-Z0-9]{17}$/i.test(d.vin)) ok = false;
      if (this.needsLegal() && !st.legal) ok = false;
      return ok;
    }
    return true;
  };
  Configurator.prototype.firstInvalid = function () {
    for (var i = 0; i < this.steps.length - 1; i++) if (!this.stepValid(i)) return i;
    return -1;
  };

  /* ---------- Actions ---------- */

  Configurator.prototype.setYear = function (y) {
    var self = this;
    this.state.year = y;
    // Drop any picks that don't fit this model year (e.g. non-Akrapovič midpipes on 2026+ cars)
    arr(this.d.steps).forEach(function (st) {
      var s = self.selOf(st), ok = {};
      self.visible(st).forEach(function (pr) { ok[pr.id] = true; });
      Object.keys(s.items).forEach(function (pid) { if (!ok[pid]) delete s.items[pid]; });
      if (s.mode === 'products' && !Object.keys(s.items).length) s.mode = null;
      if (self.isNewer() && st.hideAfterSplit) { s.mode = null; s.items = {}; }
    });
    this.buildSteps();
  };
  Configurator.prototype.pick = function (st, pid) {
    var s = this.selOf(st), pr = this.products[pid];
    var vid = this.state.pending[pid] || (pr.variants.filter(function (v) { return v.available; })[0] || pr.variants[0]).id;
    if (s.items[pid]) {
      delete s.items[pid];
      if (!Object.keys(s.items).length) s.mode = null;
    } else {
      if (!st.multi) s.items = {};
      s.items[pid] = vid;
      s.mode = 'products';
    }
  };
  // Height of the theme's sticky header, so we never scroll content underneath it
  function headerOffset() {
    var max = 0;
    document.querySelectorAll('header, [class*="header"], sticky-header, store-header').forEach(function (h) {
      var cs = window.getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = h.getBoundingClientRect();
      if (r.height > max && r.height < window.innerHeight / 2) max = r.height;
    });
    return max;
  }
  Configurator.prototype.go = function (i) {
    this.state.step = Math.max(0, Math.min(i, this.steps.length - 1));
    this.render();
    // Bring the top of the step (progress bar) into view, just below the sticky header
    var anchor = this.el.querySelector('[data-r44t-progress]') || this.el;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    if (Math.abs(window.pageYOffset - top) > 4) window.scrollTo(0, top);
  };

  /* ---------- Rendering ---------- */

  Configurator.prototype.render = function () {
    this.renderProgress();
    this.renderPanel();
    this.renderNav();
    this.renderSide();
    this.save();
  };

  Configurator.prototype.renderProgress = function () {
    var self = this, cur = this.state.step;
    this.el.querySelector('[data-r44t-progress]').innerHTML = this.steps.map(function (s, i) {
      var reachable = i <= cur || self.firstInvalid() === -1 || i <= self.firstInvalid();
      return '<li class="' + (i === cur ? 'is-current ' : '') + (i < cur ? 'is-done' : '') + '">' +
        '<button type="button" data-go="' + i + '"' + (reachable ? '' : ' disabled') + (i === cur ? ' aria-current="step"' : '') + '>' +
        '<span>' + (i + 1) + '</span>' + esc(s.title) + '</button></li>';
    }).join('');
  };

  Configurator.prototype.card = function (pr, selected, scope) {
    var self = this;
    var vid = selected || this.state.pending[pr.id] || (pr.variants.filter(function (v) { return v.available; })[0] || pr.variants[0]).id;
    var v = this.variantOf(pr.id, vid) || pr.variants[0];
    var multiVar = pr.variants.length > 1;
    return '<div class="r44t-card' + (selected ? ' is-selected' : '') + '">' +
      '<button type="button" class="r44t-card__hit" data-pick="' + pr.id + '" data-scope="' + scope + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
        (pr.image ? '<img src="' + esc(pr.image) + '" alt="" loading="lazy" width="300" height="300">' : '<span class="r44t-card__noimg"></span>') +
        '<span class="r44t-card__body">' +
          (pr.vendor ? '<span class="r44t-card__vendor">' + esc(pr.vendor) + '</span>' : '') +
          '<span class="r44t-card__title">' + esc(pr.title) + '</span>' +
          '<span class="r44t-card__price">' + this.fmt(v.price) +
            (v.compareAt > v.price ? ' <s>' + this.fmt(v.compareAt) + '</s>' : '') + '</span>' +
          (v.inStock ? '<span class="r44t-badge">In stock</span>' : '') +
        '</span>' +
        '<span class="r44t-card__tick" aria-hidden="true">' + (selected ? '✓ Selected' : 'Select') + '</span>' +
      '</button>' +
      (multiVar ? '<label class="r44t-card__var"><span class="r44t-sr">Option</span><select data-variant="' + pr.id + '" data-scope="' + scope + '">' +
        pr.variants.map(function (x) {
          return '<option value="' + x.id + '"' + (String(x.id) === String(v.id) ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' +
            esc(x.title) + ' — ' + self.fmt(x.price) + '</option>';
        }).join('') + '</select></label>' : '') +
      '<a class="r44t-card__link" href="' + esc(pr.url) + '" target="_blank" rel="noopener">View details</a>' +
    '</div>';
  };

  Configurator.prototype.renderPanel = function () {
    var s = this.steps[this.state.step], st = this.state, self = this, h = '';
    var panel = this.el.querySelector('[data-r44t-panel]');

    if (s.type === 'car') {
      var years = [], now = new Date().getFullYear() + 1;
      for (var y = now; y >= (this.p.yearFrom || now - 3); y--) years.push(y);
      h += '<h3 class="r44t-step-h">Tell us about your ' + esc(this.p.shortName) + '</h3>';
      if (arr(this.p.bodies).length) {
        h += '<p class="r44t-label">Body style</p><div class="r44t-chips">' + this.p.bodies.map(function (b) {
          return '<button type="button" class="r44t-chip' + (st.body === b ? ' is-on' : '') + '" data-body="' + esc(b) + '" aria-pressed="' + (st.body === b) + '">' + esc(b) + '</button>';
        }).join('') + '</div>';
      }
      h += '<label class="r44t-label" for="r44t-year">Model year</label><select id="r44t-year" class="r44t-input" data-year>' +
        '<option value="">Select year</option>' + years.map(function (yy) {
          return '<option' + (String(st.year) === String(yy) ? ' selected' : '') + '>' + yy + '</option>';
        }).join('') + '</select>';
      if (this.p.splitNote && this.isNewer()) h += '<p class="r44t-note">' + esc(this.p.splitNote) + '</p>';
    }

    if (s.type === 'step') {
      var step = s.step, sel = this.selOf(step), list = this.visible(step);
      h += '<h3 class="r44t-step-h">' + esc(step.title) + (step.required ? '' : ' <span class="r44t-opt">Optional</span>') + '</h3>';
      if (step.intro) h += '<p class="r44t-intro">' + esc(step.intro) + '</p>';
      if (this.isNewer() && step.productsAfterSplit.length && this.p.splitNote) h += '<p class="r44t-note">' + esc(this.p.splitNote) + '</p>';
      if (step.allowFitted || step.allowSkip) {
        h += '<div class="r44t-chips">';
        if (step.allowFitted) h += '<button type="button" class="r44t-chip' + (sel.mode === 'fitted' ? ' is-on' : '') + '" data-mode="fitted">Already fitted to my car</button>';
        if (step.allowSkip) h += '<button type="button" class="r44t-chip' + (sel.mode === 'skip' ? ' is-on' : '') + '" data-mode="skip">' + esc(step.skipLabel || 'Not needed') + '</button>';
        h += '</div>';
      }
      h += '<p class="r44t-hint">' + (step.multi ? 'Choose as many as you like.' : 'Choose one.') + '</p>';
      h += '<div class="r44t-grid">' + list.map(function (pr) { return self.card(pr, sel.items[pr.id], step.id); }).join('') + '</div>';
      var ns = this.nextStage();
      if (step.key && ns && ns.missing.length) {
        h += '<p class="r44t-nudge">Add ' + esc(ns.missing.join(' + ')) + ' to unlock <strong>' + esc(ns.stage.name) + '</strong>' +
          (ns.stage.hp ? ' (' + ns.stage.hp + ' hp / ' + ns.stage.nm + ' Nm)' : '') + '.</p>';
      }
    }

    if (s.type === 'upsell') {
      var g = this.upsells[st.upsellTab] || this.upsells[0];
      h += '<h3 class="r44t-step-h">Complete the build <span class="r44t-opt">Optional</span></h3>' +
        '<p class="r44t-intro">While your car is with us, add the parts that finish it off.</p>';
      if (this.upsells.length > 1) {
        h += '<div class="r44t-chips" role="tablist">' + this.upsells.map(function (x, i) {
          return '<button type="button" role="tab" class="r44t-chip' + (x === g ? ' is-on' : '') + '" aria-selected="' + (x === g) + '" data-tab="' + i + '">' + esc(x.title) + '</button>';
        }).join('') + '</div>';
      }
      h += '<div class="r44t-grid">' + g.products.map(function (pr) { return self.card(pr, st.upsell[pr.id], 'upsell'); }).join('') + '</div>';
      if (g.url) h += '<p><a class="r44t-link" href="' + esc(g.url) + '" target="_blank" rel="noopener">See all ' + esc(g.title) + '</a></p>';
    }

    if (s.type === 'details') {
      var d = st.details;
      var f = function (key, label, type, req, extra) {
        return '<label class="r44t-field"><span>' + label + (req ? ' *' : '') + '</span>' +
          (type === 'textarea'
            ? '<textarea class="r44t-input" rows="3" data-detail="' + key + '">' + esc(d[key]) + '</textarea>'
            : '<input class="r44t-input" type="' + type + '" data-detail="' + key + '" value="' + esc(d[key]) + '"' + (req ? ' required' : '') + (extra || '') + '>') +
          '</label>';
      };
      var minDate = new Date(Date.now() + 7 * 864e5).toISOString().slice(0, 10);
      h += '<h3 class="r44t-step-h">Your details</h3><p class="r44t-intro">We pass these to the workshop so your car is ready to go on the day.</p>' +
        '<div class="r44t-fields">' +
          f('reg', 'Registration', 'text', true, ' autocomplete="off" style="text-transform:uppercase"') +
          f('vin', 'VIN (optional)', 'text', false, ' maxlength="17" style="text-transform:uppercase"') +
          f('mileage', 'Mileage', 'number', true, ' min="0" inputmode="numeric"') +
          f('phone', 'Contact phone', 'tel', true, ' autocomplete="tel"') +
          f('date', 'Preferred drop-off date', 'date', false, ' min="' + minDate + '"') +
          f('mods', 'Existing modifications', 'textarea', false) +
        '</div>';
      if (d.vin && !/^[A-HJ-NPR-Z0-9]{17}$/i.test(d.vin)) h += '<p class="r44t-error">VINs are 17 characters (no I, O or Q).</p>';
      if (this.needsLegal()) {
        h += '<label class="r44t-legal"><input type="checkbox" data-legal' + (st.legal ? ' checked' : '') + '> <span>' + esc(this.cfg.legalText) +
          (this.cfg.disclaimerUrl ? ' <a href="' + esc(this.cfg.disclaimerUrl) + '" target="_blank" rel="noopener">Read our disclaimer</a>.' : '') + '</span></label>';
      }
    }

    if (s.type === 'review') {
      var stg = this.stage(), lines = this.lines(), groups = {};
      lines.forEach(function (l) { (groups[l.group] = groups[l.group] || []).push(l); });
      h += '<h3 class="r44t-step-h">Review your package</h3>';
      h += '<div class="r44t-review__car"><strong>' + esc(this.carLabel()) + '</strong>' +
        (stg ? '<span class="r44t-stagepill">' + esc(stg.name) + (stg.hp ? ' · ' + stg.hp + ' hp / ' + stg.nm + ' Nm' : '') + '</span>' : '') + '</div>';
      if (!stg || !stg.variant) h += '<p class="r44t-error">We couldn\'t match a tune to this hardware. Please send the build to a Build Consultant and we\'ll sort it.</p>';
      ['Tune', 'Hardware', 'Services', 'Build upgrades'].forEach(function (gname) {
        if (!groups[gname]) return;
        h += '<h4 class="r44t-review__h">' + gname + '</h4><ul class="r44t-lines">' + groups[gname].map(function (l) {
          return '<li><span>' + (l.qty > 1 ? l.qty + ' × ' : '') + esc(l.title) + (l.variant && l.variant !== 'Default Title' ? ' <small>' + esc(l.variant) + '</small>' : '') +
            (l.included ? ' <small>Included</small>' : '') + (l.auto ? ' <small>Added automatically</small>' : '') + '</span><span>' + self.fmt(l.price * (l.qty || 1)) + '</span></li>';
        }).join('') + '</ul>';
      });
      h += '<div class="r44t-total"><span>Total</span><strong>' + this.fmt(this.total()) + '</strong></div>';
      h += '<p class="r44t-error" data-r44t-cart-error hidden></p>';
    }

    panel.innerHTML = h;
  };

  Configurator.prototype.carLabel = function () {
    var st = this.state;
    return this.p.name + (st.body ? ' — ' + st.body : '') + (st.year ? ' (' + st.year + ')' : '');
  };

  Configurator.prototype.renderNav = function () {
    var i = this.state.step, last = i === this.steps.length - 1, valid = this.stepValid(i);
    var ready = this.firstInvalid() === -1 && this.stage() && this.stage().variant;
    var h = '';
    if (i > 0) h += '<button type="button" class="r44t-btn r44t-btn--ghost" data-back>Back</button>';
    if (!last) h += '<button type="button" class="r44t-btn r44t-btn--primary" data-next' + (valid ? '' : ' disabled') + '>Continue</button>';
    else h += '<button type="button" class="r44t-btn r44t-btn--primary" data-add' + (ready ? '' : ' disabled') + '>Add package to basket</button>';
    this.el.querySelector('[data-r44t-nav]').innerHTML = h;
    var mb = this.el.querySelector('[data-r44t-mbar]');
    var stg = this.stage();
    mb.innerHTML = '<div><small>' + (stg ? esc(stg.name) : 'Your package') + '</small><strong>' + this.fmt(this.total()) + '</strong></div>' +
      '<button type="button" class="r44t-mbar__help" data-consult aria-label="Talk to a Build Consultant">' + ICON_CHAT + '<span>Help</span></button>' +
      (last ? '<button type="button" class="r44t-btn r44t-btn--primary" data-add' + (ready ? '' : ' disabled') + '>Add to basket</button>'
            : '<button type="button" class="r44t-btn r44t-btn--primary" data-next' + (valid ? '' : ' disabled') + '>Continue</button>');
  };

  Configurator.prototype.renderSide = function () {
    var stg = this.stage(), lines = this.lines(), self = this, p = this.p;
    var h = '<h3 class="r44t-side__h">Your package</h3>';
    h += '<p class="r44t-side__car">' + esc(this.state.year ? this.carLabel() : p.name) + '</p>';
    if (stg) {
      h += '<div class="r44t-side__stage"><span class="r44t-stagepill">' + esc(stg.name) + '</span>' +
        (stg.hp ? '<div class="r44t-side__figs"><strong>' + stg.hp + '</strong> hp <strong>' + stg.nm + '</strong> Nm' +
          (p.stockHp ? '<small>+' + (stg.hp - p.stockHp) + ' hp / +' + (stg.nm - p.stockNm) + ' Nm</small>' : '') + '</div>' : '') + '</div>';
    }
    if (lines.length) {
      h += '<ul class="r44t-lines r44t-lines--side">' + lines.map(function (l) {
        return '<li><span>' + (l.qty > 1 ? l.qty + ' × ' : '') + esc(l.title) + '</span><span>' + self.fmt(l.price * (l.qty || 1)) + '</span></li>';
      }).join('') + '</ul>';
    } else {
      h += '<p class="r44t-muted">Pick your hardware and we\'ll match the right tune.</p>';
    }
    h += '<div class="r44t-total"><span>Total</span><strong>' + this.fmt(this.total()) + '</strong></div>';
    h += '<button type="button" class="r44t-reset" data-reset>Start again</button>';
    h += this.helpBox();
    this.el.querySelector('[data-r44t-side]').innerHTML = h;
  };

  // Build Consultant panel shown under the package summary
  Configurator.prototype.helpBox = function () {
    var cfg = this.cfg;
    var who = cfg.consultant ? esc(cfg.consultant) + ' and the R44 team' : 'Our Build Consultants';
    return '<div class="r44t-help">' +
      '<div class="r44t-help__top">' +
        (cfg.consultantPhoto ? '<img class="r44t-help__avatar" src="' + esc(cfg.consultantPhoto) + '" alt="" width="48" height="48">' : '<span class="r44t-help__avatar r44t-help__avatar--icon">' + ICON_CHAT + '</span>') +
        '<div><p class="r44t-help__h">Not sure what you need?</p><p class="r44t-help__sub">Free advice, no obligation</p></div>' +
      '</div>' +
      '<p class="r44t-help__p">' + who + ' can check fitment, recommend the right hardware and book your drop-off.</p>' +
      '<button type="button" class="r44t-btn r44t-btn--light r44t-btn--block" data-consult>' + ICON_CHAT + 'Talk to a Build Consultant</button>' +
      (cfg.whatsapp ? '<a class="r44t-help__wa" data-wa-side target="_blank" rel="noopener" href="' + esc(this.waLink()) + '">' + ICON_PHONE + 'Or message us on WhatsApp</a>' : '') +
    '</div>';
  };
  Configurator.prototype.waLink = function () {
    return 'https://wa.me/' + (this.cfg.whatsapp || '') + '?text=' + encodeURIComponent('Hi R44, I\'d like to talk about this tuning package:\n\n' + this.summary());
  };

  /* ---------- Summary text (consultant hand-off + WhatsApp) ---------- */

  Configurator.prototype.summary = function () {
    var stg = this.stage(), d = this.state.details, self = this;
    var out = ['Tuning package ' + this.state.buildId, this.carLabel()];
    if (stg) out.push('Stage: ' + stg.name + (stg.hp ? ' (' + stg.hp + ' hp / ' + stg.nm + ' Nm)' : ''));
    this.activeSteps().forEach(function (st) {
      var s = self.selOf(st);
      if (s.mode === 'fitted') out.push(st.title + ': already fitted');
      if (s.mode === 'skip') out.push(st.title + ': ' + (st.skipLabel || 'not needed'));
    });
    this.lines().forEach(function (l) { out.push('- ' + (l.qty > 1 ? l.qty + ' x ' : '') + l.title + (l.variant && l.variant !== 'Default Title' ? ' (' + l.variant + ')' : '') + ' ' + self.fmt(l.price * (l.qty || 1))); });
    out.push('Total: ' + this.fmt(this.total()));
    if (d.reg) out.push('Reg: ' + d.reg.toUpperCase());
    if (d.mileage) out.push('Mileage: ' + d.mileage);
    if (d.mods) out.push('Existing mods: ' + d.mods);
    out.push(this.cfg.pageUrl || window.location.href);
    return out.join('\n');
  };

  Configurator.prototype.eventProps = function () {
    var stg = this.stage();
    return {
      BuildId: this.state.buildId,
      Platform: this.p.name,
      PlatformHandle: this.p.handle,
      Body: this.state.body,
      ModelYear: this.state.year,
      Stage: stg ? stg.name : null,
      Items: this.lines().map(function (l) { return l.title; }),
      $value: this.total() / 100,
      URL: this.cfg.pageUrl || window.location.href
    };
  };

  function klaviyo(identity, event, props) {
    try {
      var k = window.klaviyo;
      if (!k) return Promise.resolve();
      var jobs = [];
      if (identity && typeof k.identify === 'function') jobs.push(k.identify(identity));
      else if (identity && k.push) k.push(['identify', identity]);
      if (typeof k.track === 'function') jobs.push(k.track(event, props));
      else if (k.push) k.push(['track', event, props]);
      return Promise.race([Promise.all(jobs.map(function (j) { return Promise.resolve(j).catch(function () {}); })), new Promise(function (r) { setTimeout(r, 1500); })]);
    } catch (e) { return Promise.resolve(); }
  }

  /* ---------- Basket ---------- */

  Configurator.prototype.addToCart = function (btn) {
    var self = this, stg = this.stage(), st = this.state, d = st.details;
    if (!stg || !stg.variant) return;
    var pkg = this.p.shortName + ' — ' + stg.name;
    var hw = [];
    var tuneProps = {
      'Vehicle': this.carLabel(),
      'Registration': (d.reg || '').toUpperCase(),
      'Mileage': d.mileage || ''
    };
    if (d.vin) tuneProps['VIN'] = d.vin.toUpperCase();
    if (d.phone) tuneProps['Contact phone'] = d.phone;
    if (d.date) tuneProps['Preferred drop-off'] = d.date;
    if (d.mods) tuneProps['Existing mods'] = d.mods;
    this.activeSteps().forEach(function (s2) {
      var s = self.selOf(s2);
      if (s.mode === 'fitted') hw.push(s2.title + ' (already fitted)');
      if (s.mode === 'products') Object.keys(s.items).forEach(function (pid) {
        if (s2.key) hw.push(self.products[pid].title);
        if (s2.propertyLabel) tuneProps[s2.propertyLabel] = self.products[pid].title;
      });
    });
    if (hw.length) tuneProps['Hardware'] = hw.join(', ');
    if (this.needsLegal()) tuneProps['Legal disclaimer accepted'] = 'Yes';
    tuneProps['_tuning_build_id'] = st.buildId;
    tuneProps['_tuning_platform'] = this.p.handle;

    var items = this.lines().map(function (l) {
      if (l.tune) return { id: l.id, quantity: 1, properties: tuneProps };
      if (l.auto) return { id: l.id, quantity: l.qty, properties: { '_tuning_build_id': st.buildId, 'Tuning package': pkg } };
      var props = { '_tuning_build_id': st.buildId };
      if (l.upsell) props['_tuning_source'] = 'upsell';
      else props['Tuning package'] = pkg;
      return { id: l.id, quantity: 1, properties: props };
    });

    var err = this.el.querySelector('[data-r44t-cart-error]');
    this.el.querySelectorAll('[data-add]').forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; });
    }).then(function () {
      return klaviyo(null, 'Added Tuning Package', self.eventProps());
    }).then(function () {
      store(self.saveKey, null);
      window.location.href = root + (self.cfg.afterAdd === 'checkout' ? 'checkout' : 'cart');
    }).catch(function (e) {
      if (err) { err.hidden = false; err.textContent = e.message + ' — please try again or send the build to a Build Consultant.'; }
      self.renderNav();
    });
  };

  /* ---------- Build Consultant modal ---------- */

  Configurator.prototype.modal = function () {
    return this.el.parentNode.querySelector('[data-r44t-modal]');
  };
  Configurator.prototype.openModal = function () {
    var m = this.modal();
    if (!m) return;
    var body = m.querySelector('[data-r44t-body]');
    if (body) body.value = this.summary();
    var wa = m.querySelector('[data-r44t-wa]');
    if (wa) wa.href = this.waLink();
    var prev = m.querySelector('[data-r44t-modal-build]');
    if (prev) {
      var stg = this.stage(), n = this.lines().length;
      prev.innerHTML = this.state.year
        ? '<span>' + esc(this.carLabel()) + '</span><strong>' + (stg ? esc(stg.name) + ' · ' : '') + n + ' item' + (n === 1 ? '' : 's') + ' · ' + this.fmt(this.total()) + '</strong>'
        : '<span>Your build so far</span><strong>We\'ll go through the options with you</strong>';
    }
    m.hidden = false;
    document.documentElement.classList.add('r44t-lock');
    var first = m.querySelector('input, button');
    if (first) first.focus();
  };
  Configurator.prototype.closeModal = function () {
    var m = this.modal();
    if (m) m.hidden = true;
    document.documentElement.classList.remove('r44t-lock');
  };

  /* ---------- Events ---------- */

  Configurator.prototype.bind = function () {
    var self = this, el = this.el;

    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-r44t-open-consult]');
      if (o) { e.preventDefault(); self.openModal(); }
    });

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-wa-side]')) klaviyo(null, 'Tuning Package WhatsApp Click', self.eventProps());
      var t = e.target.closest('button');
      if (!t || !el.contains(t)) return;
      var cur = self.steps[self.state.step];

      if (t.hasAttribute('data-go')) return self.go(+t.getAttribute('data-go'));
      if (t.hasAttribute('data-next')) {
        if (!self.stepValid(self.state.step)) return;
        return self.go(self.state.step + 1);
      }
      if (t.hasAttribute('data-back')) return self.go(self.state.step - 1);
      if (t.hasAttribute('data-add')) return self.addToCart(t);
      if (t.hasAttribute('data-consult')) return self.openModal();
      if (t.hasAttribute('data-reset')) {
        if (!window.confirm('Clear your package and start again?')) return;
        self.state = self.fresh(); return self.render();
      }
      if (t.hasAttribute('data-body')) { self.state.body = t.getAttribute('data-body'); return self.render(); }
      if (t.hasAttribute('data-tab')) { self.state.upsellTab = +t.getAttribute('data-tab'); return self.render(); }
      if (t.hasAttribute('data-mode') && cur.type === 'step') {
        var s = self.selOf(cur.step), mode = t.getAttribute('data-mode');
        s.mode = s.mode === mode ? null : mode;
        s.items = {};
        return self.render();
      }
      if (t.hasAttribute('data-pick')) {
        var pid = t.getAttribute('data-pick'), scope = t.getAttribute('data-scope');
        if (scope === 'upsell') {
          var pr = self.products[pid];
          if (self.state.upsell[pid]) delete self.state.upsell[pid];
          else self.state.upsell[pid] = self.state.pending[pid] || (pr.variants.filter(function (v) { return v.available; })[0] || pr.variants[0]).id;
        } else if (cur.type === 'step') {
          self.pick(cur.step, pid);
        }
        return self.render();
      }
    });

    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-year')) { self.setYear(t.value); return self.render(); }
      if (t.hasAttribute('data-variant')) {
        var pid = t.getAttribute('data-variant'), scope = t.getAttribute('data-scope'), vid = t.value;
        self.state.pending[pid] = vid;
        if (scope === 'upsell') { if (self.state.upsell[pid]) self.state.upsell[pid] = vid; }
        else {
          var cur = self.steps[self.state.step];
          if (cur.type === 'step') { var s = self.selOf(cur.step); if (s.items[pid]) s.items[pid] = vid; }
        }
        return self.render();
      }
      if (t.hasAttribute('data-legal')) { self.state.legal = t.checked; self.renderNav(); return self.save(); }
    });

    // Typing in the details step: update state without re-rendering the field being typed in
    el.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.hasAttribute('data-detail')) return;
      self.state.details[t.getAttribute('data-detail')] = t.value.trim();
      self.renderNav();
      self.save();
    });
    el.addEventListener('focusout', function (e) {
      if (e.target.getAttribute && e.target.getAttribute('data-detail') === 'vin') self.renderPanel();
    });

    var m = this.modal();
    if (m) {
      m.addEventListener('click', function (e) {
        if (e.target === m || e.target.closest('[data-r44t-close]')) self.closeModal();
        if (e.target.closest('[data-r44t-wa]')) klaviyo(null, 'Tuning Package WhatsApp Click', self.eventProps());
        var send = e.target.closest('[data-r44t-send]');
        if (send) {
          var form = m.querySelector('form');
          if (!form.reportValidity()) return;
          var email = form.querySelector('[name="contact[email]"]').value.trim();
          var name = form.querySelector('[name="contact[name]"]').value.trim();
          m.querySelector('[data-r44t-body]').value = self.summary();
          send.disabled = true; send.textContent = 'Sending…';
          klaviyo({ email: email, first_name: name.split(' ')[0] }, 'Tuning Package Configured', self.eventProps()).then(function () {
            // Click a real submit button so Shopify's spam protection runs as normal
            m.querySelector('[data-r44t-submit]').click();
          });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) self.closeModal(); });
      if (m.querySelector('[data-r44t-sent]') || /contact_posted=true/.test(window.location.search)) this.openModal();
    }
  };

  function init() {
    document.querySelectorAll('[data-r44t-config]').forEach(function (el) {
      if (el.__r44t) return;
      try { el.__r44t = new Configurator(el); } catch (e) { console.error('[R44 tuning]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.R44TuningConfigurator = Configurator;
})();
